import {createApi} from "@reduxjs/toolkit/dist/query/react"
import {apiQuery, getUrl} from "../../utils/api-config";
import {Response} from "../../types/response/Response";
import {EmployeeGetParams, EmployeeSelfDTO} from "../../types/auth/EmployeeSelfDTO";
import {EmployeeUpdateDTO} from "../../types/auth/EmployeeUpdateDTO";
import {EmployeePageableDTO} from "../../types/auth/EmployeePageableDTO";
import {EmployeeCreateDTO} from "../../types/auth/EmployeeCreateDTO";
import {DeleteParams} from "../../types/utils/Constants";

export const employeeApi = createApi({
    reducerPath: "employee",
    baseQuery: apiQuery,
    tagTypes: ["self", "employees", "employee"],
    endpoints: builder => ({
        getSelfEmployee: builder.query<Response<EmployeeSelfDTO>, void>({
            query: () => '/employees/self',
            providesTags: ['self']
        }),
        getEmployees: builder.query<Response<EmployeePageableDTO>, Partial<EmployeeGetParams>>({
            query: (params) => getUrl("/employees", [
                {
                    name: "page",
                    value: params.page
                },
                {
                    name: "size",
                    value: params.size
                },
                {
                    name: "search_text",
                    value: params.search_text
                },
                {
                    name: "account_id",
                    value: params.account_id
                },
            ]),
            providesTags: ["employees"]
        }),
        getEmployeeById: builder.query<Response<EmployeeSelfDTO>, Partial<number | undefined>>({
            query: (id) => `/employees/${id}`,
            providesTags: ["employee"]
        }),
        updateEmployee: builder.mutation<void, Partial<EmployeeUpdateDTO>>({
            query: (body) => ({
                url: `/employees/${body.id}`,
                method: "PATCH",
                body
            }),
            invalidatesTags: ["employees", "employee"]
        }),
        createEmployee: builder.mutation<void, Partial<EmployeeCreateDTO>>({
            query: (body) => ({
                url: "/employees",
                method: "POST",
                body
            })
        }),
        deleteEmployee: builder.mutation<void, Partial<DeleteParams>>({
            query: (params) => ({
                url: `/employees/${params.id}`,
                method: "DELETE"
            }),
            invalidatesTags: ["employees"]
        })
    })
})

export const {
    useGetSelfEmployeeQuery,
    useLazyGetEmployeesQuery,
    useGetEmployeesQuery,
    useGetEmployeeByIdQuery,
    useUpdateEmployeeMutation,
    useCreateEmployeeMutation,
    useDeleteEmployeeMutation
} = employeeApi
